import utils from 'utils'

export default class taxpayerSettingCtrl {
    constructor($scope, httpRequest, logger, $uibModal, sweetalert, $rootScope, modalSelConDetailService) {
        function init() {
            $scope.saleInfo = {}
            $scope.dictData = {}
            $scope.banklist = []
            $scope.disableSw = false
            const typecodeArr = ['register_type', 'business_type', 'accounting_system', 'industry_classification', 'taxplayer_type', 'disk_type', 'tax_disk_type', 'disk_device_type', 'department_no', 'ivat_service_platform_type', 'tax_belong_region']
            httpRequest.get_dictByTypeArr(typecodeArr).then((res) => {
                $scope.dictData = $.extend($scope.dictData, res.data.value)
                $scope.dictData.company_property = [
                    {
                        enumCode: '0',
                        enumName: '否',
                    },
                    {
                        enumCode: '1',
                        enumName: '是',
                    },
                ]
                // 暂不确定 是否只显示两个纳税人
                // $scope.dictData.taxplayer_type = $scope.dictData.taxplayer_type.filter(
                //   (item) => {
                //     return (
                //       item.enumName === '一般纳税人' || item.enumName === '小规模纳税人'
                //     )
                //   }
                // )
                // 优化 使用设备类型屏蔽‘两者都有’
                $scope.dictData.disk_device_type = $scope.dictData.disk_device_type.filter((item) => {
                    return item.enumName === '航信金税盘' || item.enumName === '百旺税控盘' || item.enumName === '税务ukey'
                })
            })
        }
        init()
        getSale(1)
        // getBankList()

        function getSale(p) {
            httpRequest.get_getUserSaleInfo().then((res) => {
                $scope.saleInfo = res.data.value
                if (!$scope.saleInfo) {
                    logger.logTips('当前机构下没有配置纳税人识别号，请补充', 'warn')
                    return
                }
                let userInfo = JSON.parse(localStorage.user_info)
                userInfo.sale = $scope.saleInfo
                localStorage.user_info = JSON.stringify(userInfo)
                if (!$scope.saleInfo.companyProperty) {
                    $scope.saleInfo.companyProperty = '0'
                }
                if (p) {
                    getBankList()
                }
            })
        }

        function getBankList() {
            httpRequest.post_bankBySale().then((res) => {
                $scope.banklist = res.data.value
            })
        }

        $scope.editSaleInfo = function editSaleInfo(type) {
            if (!$scope.saleInfo) {
                return
            }
            $uibModal
                .open({
                    templateUrl: 'editTaxpayerInfo.html',
                    openedClass: 'mod-modal modal-edit-taxpayer-container',
                    animation: true,
                    controller: [
                        '$scope',
                        'obj',
                        '$uibModalInstance',
                        'logger',
                        'httpRequest',
                        function ($scope, obj, $uibModalInstance, logger, httpRequest) {
                            console.log(obj)
                            $scope.saleInfo = {}
                            $scope.settingType = obj.settingType
                            $scope.dictData = obj.dictData

                            // 获取所有主管税局信息--百丽接口
                            function getAllTaxBureau() {
                                httpRequest.get_getAllTaxBureau(localStorage.getItem('id_token')).then((res) => {
                                    $scope.taxBureauList = res.data.value
                                })
                            }
                            getAllTaxBureau()
                            // 百丽--获取地区时两个参数都不传，获取管理城市时两个都要传--百丽接口
                            function getBelleRegion() {
                                httpRequest.get_getBelleRegion().then((res) => {
                                    $scope.belleRegionList = res.data.value
                                })
                            }
                            getBelleRegion()
                            // 字典
                            // httpRequest
                            //   .get_dictByTypeArr('["department_no","taxplayer_type"]')
                            //   .then((res) => {
                            //     $scope.dictData = $.extend($scope.dictData, res.data.value) //纳税人类型
                            //   })
                            $scope.saleInfo.saleId = obj.saleInfo.saleId
                            if ($scope.settingType === 1) {
                                $scope.saleInfo.saleName = obj.saleInfo.saleName
                                $scope.saleInfo.saleCreditCode = obj.saleInfo.saleCreditCode
                                $scope.saleInfo.registerType = obj.saleInfo.registerType
                                $scope.saleInfo.taxplayerType = obj.saleInfo.taxplayerType
                                $scope.saleInfo.accountingCode = obj.saleInfo.accountingCode
                                $scope.saleInfo.industryCode = obj.saleInfo.industryCode
                                $scope.saleInfo.registerAddress = obj.saleInfo.registerAddress
                                $scope.saleInfo.phone = obj.saleInfo.phone
                                $scope.saleInfo.companyProperty = obj.saleInfo.companyProperty
                                $scope.saleInfo.taxBureauId = obj.saleInfo.taxBureauId
                                $scope.saleInfo.departmentNo = obj.saleInfo.departmentNo
                                $scope.saleInfo.regionNo = obj.saleInfo.regionNo
                                $scope.saleInfo.managerCityNo = obj.saleInfo.managerCityNo
                                $scope.saleInfo.taxBelongRegion = obj.saleInfo.taxBelongRegion
                            }
                            // 选择大区&&事业部查询
                            $scope.searchManagCity = function () {
                                let params = {
                                    affiliation: $scope.saleInfo.departmentNo,
                                    regionNo: $scope.saleInfo.regionNo,
                                }
                                httpRequest.get_getBelleRegion(params).then((res) => {
                                    $scope.belleRegionNameList = res.data.value
                                })
                            }
                            $scope.searchManagCity()
                            if ($scope.settingType === 2) {
                                $scope.saleInfo.saleBankAccount = {
                                    accountId: obj.saleInfo.saleBankAccount ? obj.saleInfo.saleBankAccount.accountId : '',
                                    bank: obj.saleInfo.saleBankAccount ? obj.saleInfo.saleBankAccount.bank : '',
                                    bankAccount: obj.saleInfo.saleBankAccount ? obj.saleInfo.saleBankAccount.bankAccount : '',
                                }
                                // $scope.saleInfo.taxDiskType = obj.saleInfo.taxDiskType ? obj.saleInfo.taxDiskType : '2'
                                // $scope.saleInfo.soapPort = obj.saleInfo.soapPort
                                // $scope.saleInfo.platformCode = obj.saleInfo.platformCode
                                // $scope.saleInfo.platformPassword = obj.saleInfo.platformPassword
                                // $scope.saleInfo.authCode = obj.saleInfo.authCode
                            }
                            if ($scope.settingType === 3) {
                                $scope.saleInfo.orgId = JSON.parse(localStorage.user_info).org.orgId
                                $scope.initDisable = obj.saleInfo.ivatCollectServer && obj.saleInfo.ivatCollectServer.serverAddress ? true : false
                                $scope.saleInfo.ivatCollectServer = {
                                    serverId: obj.saleInfo.ivatCollectServer && obj.saleInfo.ivatCollectServer.serverId ? obj.saleInfo.ivatCollectServer.serverId : '',
                                    platformPassword: obj.saleInfo.ivatCollectServer && obj.saleInfo.ivatCollectServer.platformPassword ? obj.saleInfo.ivatCollectServer.platformPassword : '',
                                    diskType: obj.saleInfo.ivatCollectServer && obj.saleInfo.ivatCollectServer.diskType ? obj.saleInfo.ivatCollectServer.diskType : '1',
                                    deviceType: obj.saleInfo.ivatCollectServer && obj.saleInfo.ivatCollectServer.deviceType ? obj.saleInfo.ivatCollectServer.deviceType : '1',
                                    diskPassword: obj.saleInfo.ivatCollectServer && obj.saleInfo.ivatCollectServer.diskPassword ? obj.saleInfo.ivatCollectServer.diskPassword : '12345678',
                                    deductionPassword: obj.saleInfo.ivatCollectServer && obj.saleInfo.ivatCollectServer.deductionPassword ? obj.saleInfo.ivatCollectServer.deductionPassword : '',
                                    ivatServicePlatform: obj.saleInfo.ivatCollectServer && obj.saleInfo.ivatCollectServer.ivatServicePlatform ? obj.saleInfo.ivatCollectServer.ivatServicePlatform : '0',
                                    ivatPlatformUsername: obj.saleInfo.ivatCollectServer && obj.saleInfo.ivatCollectServer.ivatPlatformUsername ? obj.saleInfo.ivatCollectServer.ivatPlatformUsername : '',
                                    ivatPlatformPassword: obj.saleInfo.ivatCollectServer && obj.saleInfo.ivatCollectServer.ivatPlatformPassword ? obj.saleInfo.ivatCollectServer.ivatPlatformPassword : '',
                                    autoCheckStatus: obj.saleInfo.ivatCollectServer && obj.saleInfo.ivatCollectServer.autoCheckStatus ? parseInt(obj.saleInfo.ivatCollectServer.autoCheckStatus) : 0,
                                }
                                $scope.$watch('saleInfo.ivatCollectServer.deviceType', (newV) => {
                                    $scope.saleInfo.ivatCollectServer.diskPassword = obj.saleInfo.ivatCollectServer && obj.saleInfo.ivatCollectServer.diskPassword ? obj.saleInfo.ivatCollectServer.diskPassword : newV == 4 ? '88888888' : '12345678'
                                })
                                $scope.saleInfo.ivatCollectServer.serverAddress = obj.saleInfo.ivatCollectServer && obj.saleInfo.ivatCollectServer.serverAddress ? obj.saleInfo.ivatCollectServer.serverAddress : $scope.saleInfo.ivatCollectServer && $scope.saleInfo.ivatCollectServer.diskType && $scope.saleInfo.ivatCollectServer.diskType == '1' ? 'https://soap.szhtxx.com:8889' : ''
                                if ($scope.saleInfo.ivatCollectServer.ivatServicePlatform == '0') {
                                    $scope.zhfwpt = true
                                    $scope.dzsj = false
                                } else {
                                    $scope.zhfwpt = false
                                    if ($scope.saleInfo.ivatCollectServer.ivatServicePlatform == '1' && ($scope.saleInfo.ivatCollectServer.diskType == 1 || $scope.saleInfo.ivatCollectServer.diskType == 2)) {
                                        $scope.dzsj = false
                                    } else {
                                        $scope.dzsj = true
                                    }
                                }
                                if ($scope.saleInfo.ivatCollectServer.ivatServicePlatform == '1' && $scope.saleInfo.ivatCollectServer.diskType == 3) {
                                    // $scope.serverAddress = true
                                    $scope.dzsj = false
                                } else {
                                    // $scope.serverAddress = true
                                }
                            }
                            $scope.selectChangeDiskType = function selectChangeDiskType() {
                                if ($scope.saleInfo.ivatCollectServer.diskType == '1') {
                                    $scope.saleInfo.ivatCollectServer.serverAddress = 'https://soap.szhtxx.com:8889'
                                }
                                if ($scope.saleInfo.ivatCollectServer.diskType == '2') {
                                    $scope.saleInfo.ivatCollectServer.serverAddress = ''
                                }
                                // if($scope.saleInfo.ivatCollectServer.ivatServicePlatform == '1' && ($scope.saleInfo.ivatCollectServer.diskType==1||$scope.saleInfo.ivatCollectServer.diskType==2)){
                                //     $scope.serverAddress = true
                                // }
                                // if($scope.saleInfo.ivatCollectServer.ivatServicePlatform == '1' && $scope.saleInfo.ivatCollectServer.diskType==3){
                                //     $scope.serverAddress = false
                                // }
                            }
                            $scope.selectChangeServicePlatform = function () {
                                if ($scope.saleInfo.ivatCollectServer.ivatServicePlatform == '0') {
                                    $scope.zhfwpt = true
                                    $scope.dzsj = false
                                } else {
                                    $scope.zhfwpt = false
                                    if ($scope.saleInfo.ivatCollectServer.ivatServicePlatform == '1' && ($scope.saleInfo.ivatCollectServer.diskType == 1 || $scope.saleInfo.ivatCollectServer.diskType == 2)) {
                                        $scope.dzsj = false
                                    } else {
                                        $scope.dzsj = true
                                    }
                                }
                                if ($scope.saleInfo.ivatCollectServer.ivatServicePlatform == '1' && $scope.saleInfo.ivatCollectServer.diskType == 3) {
                                    // $scope.serverAddress = false
                                    $scope.dzsj = false
                                }
                            }
                            $scope.cancel = function cancel() {
                                $uibModalInstance.dismiss()
                            }
                            $scope.ok = function ok() {
                                if (!checkSaleInfo($scope.settingType)) {
                                    return
                                }

                                let chooseTaxBureau = $scope.taxBureauList.filter((item) => {
                                    return item.id == $scope.saleInfo.taxBureauId
                                })
                                if (type == 1) {
                                    $scope.saleInfo.province = chooseTaxBureau[0].province
                                }
                                let interfaceName = $scope.settingType === 1 ? 'post_updateSaleBaseInfo' : $scope.settingType === 2 ? 'post_updateSaleOvatInfo' : 'post_updateSaleIvatInfo'
                                httpRequest[interfaceName]($scope.saleInfo).then((res) => {
                                    $rootScope.$broadcast('inputDevice')
                                    $uibModalInstance.close($scope.settingType)
                                    // 单机版 diskType:1 单机版，2 服务器版
                                    if ($scope.saleInfo.ivatCollectServer.diskType == '1') {
                                        //ivatServicePlatform： 0 税局综合服务平台，  1 电子发票服务平台（电子税局）
                                        const serviceObj = {
                                            taxcode: res.data.value.saleCreditCode, //税号 必须要传
                                            colltchannel: '0',
                                            capass: res.data.value.ivatCollectServer.diskPassword, //ca证书密码
                                            ptpass: res.data.value.ivatCollectServer.platformPassword, //平台密码
                                        }
                                        const eleServiceObj = {
                                            taxcode: res.data.value.saleCreditCode, //税号 必须要传
                                            colltchannel: '2',
                                            eleaccount: res.data.value.ivatCollectServer.ivatPlatformUsername, //电子税务局账号
                                            elepass: res.data.value.ivatCollectServer.ivatPlatformPassword, //电子税务局密码
                                        }
                                        const singleResJson = $scope.saleInfo.ivatCollectServer.ivatServicePlatform == '0' ? JSON.stringify(serviceObj) : JSON.stringify(eleServiceObj)
                                        const b = modalSelConDetailService.Base64()
                                        const singleReqBase64 = b.encode(singleResJson)
                                        $.post({
                                            url: `${res.data.value.ivatCollectServer.serverAddress}/InvDk`,
                                            // url: 'http://192.168.83.203:7777', //测试地址
                                            data: {
                                                SID: '66660',
                                                SIDParam: singleReqBase64,
                                            },
                                            timeout: 120000,
                                        }).then(
                                            (res) => {
                                                if (JSON.parse(res).retcode == '1') {
                                                    httpRequest.post_updateIvatInfoSyncStatus('1').then((res) => {
                                                        logger.logSuccess('保存成功')
                                                    })
                                                }
                                            },
                                            () => {
                                                logger.logError('u72请求错误')
                                            }
                                        )
                                    } else {
                                        logger.logSuccess('保存成功！')
                                    }
                                })
                            }

                            function checkSaleInfo(type) {
                                //基本信息
                                if (type === 1) {
                                    $scope.saleInfo.saleName = $scope.saleInfo.saleName.trim()
                                    $scope.saleInfo.saleCreditCode = $scope.saleInfo.saleCreditCode.replace(/\s/g, '')
                                    if (!$scope.saleInfo.saleName) {
                                        logger.logError('企业名称不允许为空')
                                        return false
                                    }
                                    if ($scope.saleInfo.saleName.length < 2) {
                                        logger.logError('企业名称不能少于2个字符')
                                        return false
                                    }
                                    if (!$scope.saleInfo.saleCreditCode) {
                                        logger.logError('纳税人识别号不允许为空')
                                        return false
                                    }
                                    if (!$scope.saleInfo.taxplayerType) {
                                        logger.logError('纳税人类型不允许为空')
                                        return false
                                    }
                                    if (!$scope.saleInfo.registerAddress) {
                                        logger.logError('营业（注册）地址不允许为空')
                                        return false
                                    }
                                    if (!$scope.saleInfo.phone) {
                                        logger.logError('联系电话不允许为空')
                                        return false
                                    }
                                    if (!$scope.saleInfo.companyProperty || $scope.saleInfo.companyProperty === 0) {
                                        logger.logError('退税企业不允许为空')
                                        return false
                                    }
                                    if (!/^\d+-?\d+$/.test($scope.saleInfo.phone)) {
                                        logger.logError('联系电话格式不正确')
                                        return false
                                    }
                                    if (!$scope.saleInfo.departmentNo) {
                                        logger.logError('事业部不允许为空')
                                        return false
                                    }
                                    if (!$scope.saleInfo.regionNo) {
                                        logger.logError('所属大区不允许为空')
                                        return false
                                    }
                                    if (!$scope.saleInfo.taxBelongRegion) {
                                        logger.logError('所属地区不允许为空')
                                        return false
                                    }
                                }
                                // 销项
                                if (type === 2) {
                                    if (!$scope.saleInfo.saleBankAccount.bank) {
                                        logger.logError('开户银行不允许为空')
                                        return false
                                    }
                                    if (!$scope.saleInfo.saleBankAccount.bankAccount) {
                                        logger.logError('银行账号不允许为空')
                                        return false
                                    }
                                    // if (!$scope.saleInfo.taxDiskType) {
                                    //     logger.logError('开票方式不允许为空')
                                    //     return false
                                    // }
                                    // if (!$scope.saleInfo.soapPort) {
                                    //     logger.logError('soap端口号不允许为空')
                                    //     return false
                                    // }
                                }
                                // 进项
                                if (type === 3) {
                                    if (!$scope.saleInfo.ivatCollectServer.diskType) {
                                        logger.logError('发票采集方式不允许为空')
                                        return false
                                    }
                                    if ($scope.saleInfo.ivatCollectServer.ivatServicePlatform == 0) {
                                        //税局综合服务平台
                                        if (!$scope.saleInfo.ivatCollectServer.diskPassword) {
                                            logger.logError('CA证书密码不允许为空')
                                            return false
                                        }
                                        if ($scope.saleInfo.ivatCollectServer.diskType == '2' && !$scope.saleInfo.ivatCollectServer.serverAddress) {
                                            logger.logError('采集平台地址不允许为空')
                                            return false
                                        }
                                        if ($scope.saleInfo.ivatCollectServer.serverAddress && !/(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/.test($scope.saleInfo.ivatCollectServer.serverAddress)) {
                                            logger.logError('采集平台地址格式错误')
                                            return false
                                        }
                                    } else if ($scope.saleInfo.ivatCollectServer.ivatServicePlatform == 1) {
                                        //电子发票服务平台（电子税局）
                                        if ($scope.saleInfo.ivatCollectServer.diskType == '2' && !$scope.saleInfo.ivatCollectServer.serverAddress) {
                                            logger.logError('采集平台地址不允许为空')
                                            return false
                                        }
                                        if ($scope.saleInfo.ivatCollectServer.serverAddress && !/(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/.test($scope.saleInfo.ivatCollectServer.serverAddress)) {
                                            logger.logError('采集平台地址格式错误')
                                            return false
                                        }
                                    } else if ($scope.saleInfo.ivatCollectServer.ivatServicePlatform == 2) {
                                        //乐企数字开放平台
                                        if ($scope.saleInfo.ivatCollectServer.diskType == '2' && !$scope.saleInfo.ivatCollectServer.serverAddress) {
                                            logger.logError('采集平台地址不允许为空')
                                            return false
                                        }
                                        if ($scope.saleInfo.ivatCollectServer.serverAddress && !/(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/.test($scope.saleInfo.ivatCollectServer.serverAddress)) {
                                            logger.logError('采集平台地址格式错误')
                                            return false
                                        }
                                        if (!$scope.saleInfo.ivatCollectServer.ivatPlatformUsername) {
                                            logger.logError('用户名(电子税局)不允许为空')
                                            return false
                                        }
                                        if (!$scope.saleInfo.ivatCollectServer.ivatPlatformPassword) {
                                            logger.logError('用户密码(电子税局)不允许为空')
                                            return false
                                        }
                                    }

                                    if ($scope.saleInfo.ivatCollectServer.ivatServicePlatform == 2 && $scope.saleInfo.ivatCollectServer.diskType != 3) {
                                        logger.logError('乐企数字开放平台的采集方式为管理平台，请检查。')
                                        return false
                                    }
                                    if ($scope.saleInfo.ivatCollectServer.ivatServicePlatform == 0 && $scope.saleInfo.ivatCollectServer.diskType == 3) {
                                        logger.logError('税局综合服务平台的采集方式不允许为管理平台，请检查。')
                                        return false
                                    }
                                }
                                return true
                            }
                        },
                    ],
                    resolve: {
                        obj() {
                            return {
                                settingType: type,
                                saleInfo: $scope.saleInfo,
                                dictData: $scope.dictData,
                            }
                        },
                    },
                })
                .result.then(
                    (type) => {
                        getSale()

                        if (type === 2) {
                            getBankList()
                        }
                    },
                    () => {}
                )
        }

        $scope.editBank = function editBank(type, bankObj) {
            if (!$scope.saleInfo) {
                return
            }
            $uibModal
                .open({
                    templateUrl: 'editTaxpayerInfo.html',
                    openedClass: 'mod-modal modal-edit-taxpayer-container',
                    animation: true,
                    controller: [
                        '$scope',
                        'obj',
                        '$uibModalInstance',
                        '$filter',
                        'logger',
                        function ($scope, obj, $uibModalInstance, $filter, logger) {
                            $scope.settingType = obj.settingType
                            $scope.bank = obj.bank
                                ? $.extend(true, {}, obj.bank)
                                : {
                                      bank: '',
                                      bankAccount: '',
                                      status: 1,
                                      createUser: $scope.userInfo.user.realName,
                                      createDate: $filter('date')(new Date(), 'yyyy-MM-dd'),
                                  }
                            $scope.cancel = function cancel() {
                                $uibModalInstance.dismiss()
                            }
                            $scope.ok = function ok() {
                                if (!checkBank()) {
                                    return
                                }
                                if ($scope.settingType === 4) {
                                    httpRequest.post_addSaleBankAccount($scope.bank).then(() => {
                                        logger.logSuccess('新增成功')
                                        $uibModalInstance.close()
                                    })
                                }
                                if ($scope.settingType === 5) {
                                    httpRequest.post_updateSaleBankAccount($scope.bank).then(() => {
                                        logger.logSuccess('编辑成功')
                                        $uibModalInstance.close($scope.bank.isBasic)
                                    })
                                }
                            }

                            function checkBank() {
                                if (!$scope.bank.bank) {
                                    logger.logError('请填写开户银行')
                                    return false
                                }
                                if (!$scope.bank.bankAccount) {
                                    logger.logError('请填写银行账号')
                                    return false
                                }
                                if ($scope.bank.bank.length > 100) {
                                    logger.logError('开户银行不得超过100个字符')
                                    return false
                                }
                                if ($scope.bank.bankAccount.length > 100) {
                                    logger.logError('银行账号不得超过100个字符')
                                    return false
                                }
                                if ($scope.bank.bank.length + $scope.bank.bankAccount.length > 100) {
                                    logger.logError('开户银行和银行账号累计不得超过100个字符')
                                    return false
                                }
                                if (!utils.regExpTest($scope.bank.bankAccount, 'bankCard')) {
                                    logger.logError('银行账号格式不正确')
                                    return false
                                }
                                return true
                            }
                        },
                    ],
                    resolve: {
                        obj() {
                            if (type === 5 && bankObj) {
                                return {
                                    settingType: type,
                                    bank: bankObj,
                                }
                            } else {
                                return {
                                    settingType: type,
                                }
                            }
                        },
                    },
                })
                .result.then(
                    (isBasic) => {
                        getBankList()
                        if (isBasic) {
                            getSale()
                        }
                    },
                    () => {}
                )
        }

        $scope.deleteBank = function deleteBank(bankId) {
            sweetalert.confirm('操作提醒', '确定删除此账号？').then(() => {
                httpRequest.get_delSaleBankAccount(bankId).then(() => {
                    logger.logSuccess('删除成功')
                    getBankList()
                })
            })
        }

        $scope.enableBank = function enableBank(status, bank) {
            $scope.disableSw = true
            bank.status = status
            httpRequest
                .post_updateSaleBankAccount(bank)
                .then(
                    (res) => {
                        if (status == 1) {
                            logger.logSuccess('启用成功')
                        }
                        if (status == 0) {
                            logger.logSuccess('已禁用')
                        }
                    },
                    () => {
                        bank.status = !status
                    }
                )
                .finally(() => {
                    $scope.disableSw = false
                })
        }
    }
}
taxpayerSettingCtrl.$inject = ['$scope', 'httpRequest', 'logger', '$uibModal', 'sweetalert', '$rootScope', 'modalSelConDetailService']



// WEBPACK FOOTER //
// ./src/app/system/basedata/taxpayerSetting/taxpayerSettingCtrl.js